import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Table from "../../../core/pagination/datatable";
import { getApiBaseUrl, ADD_ACTIVITY } from "../Config/Config";
import Swal from "sweetalert2";
import { Spin, Modal, Input, Button, Form } from "antd";

const UserRequests = () => {
  const [selectedUser, setSelectedUser] = useState([]);
  console.log(selectedUser);
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [isReauthModalVisible, setIsReauthModalVisible] = useState(false);
  const [reauthAction, setReauthAction] = useState(null);
  const [reauthForm] = Form.useForm();
  const [globalLoader, setGlobalLoader] = useState(false);

  const user = JSON.parse(sessionStorage.getItem("user"));
  const currentUsername = user?.UserName || "";
  const userId = user?.UserName || 0;

  const fetchAllUsers = async () => {
    setLoadingUsers(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/getRequestUser`);
      const userData = await response.json();
      console.log(userData.ResultData, "userData.ResultData");
      setUsers(userData.ResultData);
    } catch (err) {
      console.log(err?.message);
    } finally {
      setLoadingUsers(false);
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  const handleReauthentication = async (values) => {
    try {
      const response = await fetch(`${getApiBaseUrl()}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: currentUsername,
          password: values.password,
        }),
      });

      const loginData = await response.json();

      if (loginData.status && loginData.Message === "Login successful") {
        setIsReauthModalVisible(false);
        reauthForm.resetFields();

        if (reauthAction.type === "checkUser") {
          await performActivateUser(reauthAction.record, reauthAction.notes);
        } else if (reauthAction.type === "uncheckUser") {
          await performTerminateUser(reauthAction.record);
        }
      } else {
        Swal.fire(
          "Error",
          "Reauthentication failed. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Reauthentication error:", error);
      Swal.fire(
        "Error",
        "Reauthentication failed due to a network error.",
        "error"
      );
    }
  };

  const performActivateUser = async (record, customNotes) => {
    console.log("Activating user:", record);
    const action = "Activate";
    const statusFlag = 2;

    let toggleSuccess = false;
    let notes = customNotes || `User ${action.toLowerCase()} failed`;
    setGlobalLoader(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/updateRequestUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UserId: record?.UserId,
          Name: record?.Name,
          Role: record?.Role,
          CreatedBy: user?.UserID,
          Status: statusFlag,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status && data.ResultData) {
        toggleSuccess = true;
        notes = `User ${record?.UserId} approved successfully`;
        const tempPassword = data.ResultData?.TemporaryPassword;

        if (tempPassword) {
          await Swal.fire({
            title: "User Approved!",
            html: `
            <p><strong>Temporary Password:</strong></p>
            <div style="display: flex; align-items: center; gap: 8px; justify-content: center;">
              <input id="tempPasswordInput" value="${tempPassword}" readonly 
                     style="padding: 6px; border: 1px solid #ccc; border-radius: 4px; width: 180px; text-align: center;" />
              <button id="copyPasswordBtn" class="swal2-confirm swal2-styled" style="background-color:#3085d6;">
                Copy
              </button>
            </div>
          `,
            icon: "success",
            didOpen: () => {
              const copyBtn = document.getElementById("copyPasswordBtn");
              const input = document.getElementById("tempPasswordInput");

              copyBtn.addEventListener("click", () => {
                navigator.clipboard.writeText(input.value).then(() => {
                  Swal.fire(
                    "Copied!",
                    "Temporary password copied to clipboard",
                    "success"
                  );
                });
              });
            },
          });
        } else {
          await Swal.fire("Approved!", notes, "success");
        }
      } else {
        notes = data.ResultData?.[0]?.ResultMessage || `${action} failed`;
        await Swal.fire("Error", notes, "error");
      }
    } catch (error) {
      console.error(`Error while trying to activate user:`, error);
      notes = error.message || "Unexpected error occurred during operation";
      await Swal.fire("Error", notes, "error");
    }

    try {
      const activityPayload = {
        ActivityType: 15,
        PerformedBy: user?.UserID,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: notes,
        Location: "checkuser",
        IsSucces: toggleSuccess ? 1 : 0,
      };

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(activityPayload),
      });
    } catch (error) {
      console.error("Error calling addActivity:", error);
    } finally {
      fetchAllUsers();
      setGlobalLoader(false);
    }
  };

  const performTerminateUser = async (record) => {
    const action = "Rejection";
    const statusFlag = 3;

    let toggleSuccess = false;
    let notes = `User ${action.toLowerCase()} failed`;

    try {
      const response = await fetch(`${getApiBaseUrl()}/api/updateRequestUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UserId: record?.UserId,
          Name: record?.Name,
          Role: record?.Role,
          CreatedBy: userId,
          Status: statusFlag,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status) {
        toggleSuccess = true;
        notes = `User ${record?.UserId} rejected successfully`;

        await Swal.fire("Rejected!", notes, "success");
      } else {
        notes = data.Message || `${action} failed`;
        await Swal.fire("Error", notes, "error");
      }
    } catch (error) {
      console.error(`Error while trying to Reject user:`, error);
      notes = error.message || "Unexpected network error";
      await Swal.fire("Error", notes, "error");
    }

    try {
      const activityPayload = {
        ActivityType: 15,
        PerformedBy: user?.UserID,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: notes,
        Location: "uncheckuser",
        IsSucces: toggleSuccess ? 1 : 0,
      };

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(activityPayload),
      });
    } catch (error) {
      console.error("Error calling addActivity:", error);
    } finally {
      fetchAllUsers();
    }
  };

  const handleCheck = (record) => {
    setReauthAction({ type: "checkUser", record });
    setIsReauthModalVisible(true);
  };

  const handleUncheck = async (record) => {
    const result = await Swal.fire({
      title: `Reject User?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes",
    });

    if (result.isConfirmed) {
      setReauthAction({ type: "uncheckUser", record });
      setIsReauthModalVisible(true);
    }
  };

  const statusMap = {
    1: { text: "Pending", color: "badge bg-warning" },
    2: { text: "Approved", color: "badge bg-success" },
    3: { text: "Rejected", color: "badge bg-danger" },
  };

  const columns = [
    {
      title: "User ID",
      dataIndex: "UserId",
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (text, record) => (
        <span className="userimgname">
          <Link to="#" className="userslist-img bg-img">
            <ImageWithBasePath alt="" src={record.img} />
          </Link>
          <div>
            <Link
              onClick={() => setSelectedUser(record)}
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasViewUser"
            >
              {text}
            </Link>
          </div>
        </span>
      ),
      sorter: (a, b) => a.Name.length - b.Name.length,
    },
    {
      title: "Role",
      dataIndex: "rolename",
      sorter: (a, b) => a.rolename.length - b.rolename.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (status) => {
        const { text, color } = statusMap[status] || {
          text: "Unknown",
          color: "badge bg-secondary",
        };
        return <span className={color}>{text}</span>;
      },
      sorter: (a, b) => a.Status - b.Status,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      key: "actions",
      render: (_, record) => {
        const isDisabled = record.Status !== 1;

        // Custom tooltip based on action + status
        const approveTooltip =
          record.Status === 2
            ? "Not allowed to approve again"
            : record.Status === 3
            ? "Cannot approve a rejected user"
            : "Approve this user";

        const rejectTooltip =
          record.Status === 2
            ? "Cannot reject an approved user"
            : record.Status === 3
            ? "Not allowed to reject again"
            : "Reject this user";

        return (
          <div className="action-table-data">
            <div className="edit-delete-action">
              {/* Approve button */}
              <span
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={approveTooltip}
              >
                <Link
                  className={`me-2 p-2 ${
                    isDisabled ? "disabled opacity-50 cursor-not-allowed" : ""
                  }`}
                  to="#"
                  onClick={(e) => {
                    if (isDisabled) {
                      e.preventDefault();
                      return;
                    }
                    handleCheck(record);
                  }}
                >
                  <i className="fa-solid fa-check text-success"></i>
                </Link>
              </span>

              {/* Reject button */}
              <span
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={rejectTooltip}
              >
                <Link
                  className={`me-2 p-2 ${
                    isDisabled ? "disabled opacity-50 cursor-not-allowed" : ""
                  }`}
                  to="#"
                  onClick={(e) => {
                    if (isDisabled) {
                      e.preventDefault();
                      return;
                    }
                    handleUncheck(record);
                  }}
                >
                  <i className="fa-solid fa-times text-danger"></i>
                </Link>
              </span>
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div>
      {globalLoader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      User Requests
                    </h4>
                  </ol>
                </nav>
                <h6>Manage Your Users </h6>
              </div>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set p-3"></div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {loadingUsers ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : users?.length > 0 ? (
                  <Table columns={columns} dataSource={users} />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Confirm Password"
        open={isReauthModalVisible}
        onCancel={() => {
          setIsReauthModalVisible(false);
          reauthForm.resetFields();
        }}
        footer={null}
        width={350}
      >
        <Form
          form={reauthForm}
          onFinish={handleReauthentication}
          layout="vertical"
        >
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <Input.Password
              placeholder="Enter password"
              onCopy={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Authenticate
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              onClick={() => {
                setIsReauthModalVisible(false);
                reauthForm.resetFields();
              }}
            >
              Cancel
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default UserRequests;
